import React from "react";
import { Card, Row, Col } from "antd";
import useStockItemContext from "../../../hooks/useStockItemContext";
import { useSelector } from "react-redux";

const numberToBRL = (value) =>
  (value || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

const StockItemSummaryCards = () => {
  const { translation } = useSelector((state) => state.app);
  const t = translation?.stockItem?.summaryCards || {};
  const { data } = useStockItemContext();

  const items = Array.isArray(data) ? data : [];

  const stockValue = items
    .filter((i) => i.status === "Active")
    .reduce((acc, i) => acc + (i.currentCost || 0), 0);
  const totalItems = items.filter((i) => i.status === "Active").length;
  const belowReplenishment = items
    .filter((i) => i.status === "Active")
    .filter((i) => (i.replenishmentPoint || 0) > 0)
    .filter((i) => (i.currentQty || 0) <= (i.replenishmentPoint || 0)).length;

  const cards = [
    {
      label: t.stockValue || "Valor do Estoque",
      value: numberToBRL(stockValue),
    },
    { label: t.items || "Itens", value: totalItems },
    {
      label: t.belowReplenishment || "Abaixo Repos.",
      value: belowReplenishment,
    },
  ];

  return (
    <Row type="flex" gutter={16} style={{ marginBottom: 16 }}>
      {cards.map((card) => (
        <Col key={card.label} span={8}>
          <Card size="small" bordered>
            <div style={{ fontSize: 12, color: "#888" }}>{card.label}</div>
            <div style={{ fontSize: 20, fontWeight: 600 }}>{card.value}</div>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default StockItemSummaryCards;
